import React from 'react';

const CircleTradeIcon = (props: any) => {
  const { width = '15px', height = '15px', className = '' } = props;
  return (
    (<svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 15 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      data-palette="CircleTradeIcon">
      <title>download copy 4</title>
      <g id="Spot-existing" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="my-account-balances-1"
          transform="translate(-1194.000000, -277.000000)"
          fill="#D4D4D4"
          fillRule="nonzero"
        >
          <g id="exchange" transform="translate(1194.000000, 277.000000)">
            <path
              d="M7.5,0 C3.35786133,0 0,3.35786133 0,7.5 C0,11.6421387 3.35786133,15 7.5,15 C11.6421387,15 15,11.6421387 15,7.5 C15,3.35786133 11.6421387,0 7.5,0 Z M7.5,14.0625 C3.875625,14.0625 0.9375,11.124375 0.9375,7.5 C0.9375,3.875625 3.875625,0.9375 7.5,0.9375 C11.124375,0.9375 14.0625,3.875625 14.0625,7.5 C14.0625,11.124375 11.124375,14.0625 7.5,14.0625 Z"
              id="Shape"
            />
            <path
              d="M9.09106028,3.07692308 L8.40840264,3.71536009 L9.51411572,4.74495218 L4.4230281,4.74495218 C3.8920154,4.74495218 3.46153846,5.14754404 3.46153846,5.64415924 L3.46153846,6.99296984 L4.4230281,6.99296984 L4.4230281,5.64415924 L9.51411572,5.64415924 L8.41321009,6.67375133 L9.09106028,7.30769231 L11.0140396,5.50927818 C11.2004484,5.3339047 11.2004484,5.05071068 11.0140396,4.8753372 L9.09106028,3.07692308 Z"
              id="Path"
            />
            <path
              d="M10.1923565,9.35584076 L5.1012689,9.35584076 L6.20217453,8.32624867 L5.52432434,7.69230769 L3.60134506,9.49072182 C3.41493626,9.6660953 3.41493626,9.94928932 3.60134506,10.1246628 L5.52432434,11.9230769 L6.20217453,11.2891359 L5.1012689,10.2550478 L10.1923565,10.2550478 C10.7233692,10.2550478 11.1538462,9.85245596 11.1538462,9.35584076 L11.1538462,8.00703016 L10.1923565,8.00703016 L10.1923565,9.35584076 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default CircleTradeIcon;
